import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';

class ElerhetosegLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      formTelefon: '',
      formEmail: '',
      formIdo: '',
      formMegjegyzes: '',
      modalView: false,
      viewObj: null,
      loading: false,
      helyszin: null,
      helyszinek: [],
      helyszinid: null
    };
  }

  componentDidMount() {
    // this.listElerhetoseg();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.listElerhetoseg();
      }
    }
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  listElerhetoseg = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listElerhetoseg((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getElerhetosegForm = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initElerhetoseg(id, false, (err, res) => {
      if (!err) {
        let helyszin;
        if (id) {
          helyszin = res[0].elerhetoseg && res[0].helyszin && res[0].helyszin.map((row) => {
            if (row.helyszinid === res[0].elerhetoseg.helyszinid) {
              this.setState({
                helyszinid: row.helyszinid
              });
              return row;
            }
            return '';
          });
        } else {
          helyszin = res[0].helyszin.length === 1 ? res[0].helyszin[0] : null;
          this.setState({ helyszinid: helyszin && helyszin.helyszinid });
        }

        this.setState({
          formStatus: 'DATA',
          helyszinek: res[0].helyszin,
          helyszin: helyszin,
          formTelefon: id && this.nullToString(res[0].elerhetoseg.telefon),
          formEmail: id && this.nullToString(res[0].elerhetoseg.email),
          formIdo: id && this.nullToString(res[0].elerhetoseg.ido),
          formMegjegyzes: id && this.nullToString(res[0].elerhetoseg.megjegyzes),
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  getElerhetosegView = (id) => {
    this.setState({
      formStatus: 'LOAD',
      // formId: id
    });
    Services.initElerhetoseg(id, true, (err, res) => {
      if (!err) {
        this.setState({
          viewObj: res[0],
          formStatus: 'DATA'
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleHelyszinChange = (helyszin) => {
    if (helyszin) {
      this.setState({
        helyszin: helyszin,
        helyszinid: helyszin.helyszinid
      });
    } else {
      this.setState({ helyszin: null });
    }
  }

  handleViewClick = (cell) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: cell,
    }, () => {
      this.getElerhetosegView(cell);
      this.toggleViewModal();
    });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getElerhetosegForm(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deleteElerhetoseg = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteElerhetoseg(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listElerhetoseg();
        this.props.globals.addSuccess('Elérhetőség törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formTelefon: '',
      formEmail: '',
      formIdo: '',
      formMegjegyzes: '',
      helyszin: null,
      currentId: undefined
    }, () => {
      this.toggleFormModal();
      this.getElerhetosegForm();
    });
  }

  submitForm = (e, submitObj) => {
    const {
      currentId,
      formType
    } = this.state;
    const {
      formTelefon,
      formEmail,
      formIdo,
      formMegjegyzes,
    } = submitObj;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.helyszinid = this.state.helyszinid;
      submitObj.telefon = this.emptyOrNull(formTelefon);
      submitObj.email = this.emptyOrNull(formEmail);
      submitObj.ido = this.emptyOrNull(formIdo);
      submitObj.megjegyzes = this.emptyOrNull(formMegjegyzes);

      Services.addElerhetoseg(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Elérhetőség felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listElerhetoseg();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.helyszinid = this.state.helyszinid;
      submitObj.telefon = this.emptyOrNull(formTelefon);
      submitObj.email = this.emptyOrNull(formEmail);
      submitObj.ido = this.emptyOrNull(formIdo);
      submitObj.megjegyzes = this.emptyOrNull(formMegjegyzes);

      Services.editElerhetoseg(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Elérhetőség módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listElerhetoseg();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        <React.Fragment>
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'view'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'view'} onClick={() => this.handleViewClick(cell)} />
          {this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új elérhetőség létrehozása';
      case 'MOD':
        return 'Elérhetőség módosítása';
      default:
        return '';
    }
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Elérhetőség:</h6>
        <b>Helyszín: </b>
        { this.state.viewObj && this.state.viewObj.helyszin && this.state.viewObj.elerhetoseg && this.state.viewObj.helyszin.map((row) => {
          if (row.helyszinid === this.state.viewObj.elerhetoseg.helyszinid) {
            return row.helyszinnev;
          }
          return '';
        })}
        <br />
        <b>Telefon: </b>
        {viewObj && viewObj.elerhetoseg && viewObj.elerhetoseg.telefon}
        <br />
        <b>Email cím: </b>
        {viewObj && viewObj.elerhetoseg && viewObj.elerhetoseg.email}
        <br />
        <b>Idő: </b>
        {viewObj && viewObj.elerhetoseg && viewObj.elerhetoseg.ido}
        <br />
        <b>Megjegyzés: </b>
        <br />
        <Input type="textarea" name="formMegjegyzes" id="formMegjegyzes" value={viewObj && viewObj.elerhetoseg && viewObj.elerhetoseg.megjegyzes} disabled style={{ backgroundColor: '#fff', height: '250px' }} />
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'telefon',
        text: 'Telefon',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'email',
        text: 'Email cím',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'ido',
        text: 'Idő',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

renderForm = () => {
  const {
    formTelefon,
    formEmail,
    formIdo,
    formMegjegyzes
  } = this.state;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6">
          <SelectField
            label='Helyszín:'
            name="helyszinvalaszto"
            id="helyszinvalaszto"
            placeholder="Válassz helyszínt..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            searchPromptText="Kezdj el gépelni a kereséshez..."
            loadingMessage={() => 'Keresés...'}
            isClearable
            ignoreAccents={false}
            isLoading={this.state.loading}
            onChange={this.handleHelyszinChange}
            options={this.state.helyszinek}
            value={this.state.helyszin}
            getOptionLabel={option => option.helyszinnev}
            getOptionValue={option => option.helyszinid}
            required
          />
        </div>
        <div className="col-md-6">
          <RFField
            label="Idő:"
            name="formIdo"
            maxLength="100"
            value={formIdo}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <RFField
            label="Telefon:"
            name="formTelefon"
            maxLength="100"
            value={formTelefon}
            onChange={this.handleInputChange}
          />
        </div>
        <div className="col-md-6">
          <RFField
            label="Email cím:"
            name="formEmail"
            maxLength="100"
            value={formEmail}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <RFField
            label="Megjegyzés:"
            name="formMegjegyzes"
            type="textarea"
            value={formMegjegyzes}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          {this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új elérhetőség'}
            </Button>
          )}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.listElerhetoseg(); }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
        <ModalHeader>Megtekintés</ModalHeader>
        <ModalBody>
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => this.getElerhetosegView(this.state.currentId)}
            />),
            DATA: (this.renderView())
          }[this.state.formStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="primary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={this.submitForm}
          title={this.renderFormTitle()}
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => this.getElerhetosegForm(this.state.currentId)}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
        </RFForm>
      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteElerhetoseg()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

ElerhetosegLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default ElerhetosegLista;
